import React from 'react'

const MeunSideSetting = ({ activeMenu, setActiveMenu, isAr = true }) => {
  const handleClick = (newValue) => {
    setActiveMenu(newValue)
  }

  const itemClassName = (menuKey) =>
    `cursor-pointer flex items-center gap-3 px-4 py-3 border-b border-slate-100 transition-all ${
      activeMenu === menuKey 
        ? 'bg-indigo-50 text-indigo-700 font-bold border-r-4 border-r-indigo-600' 
        : 'text-slate-600 hover:bg-slate-50'
    }`

  return (
    <div className='w-full md:w-56 shrink-0'>
      <ul className='bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden'>
        <li onClick={() => handleClick('MyAccount')} className={itemClassName('MyAccount')}>
          {isAr ? 'حسابي' : 'My Account'}
        </li>
        <li onClick={() => handleClick('ChangePassword')} className={itemClassName('ChangePassword')}>
          {isAr ? 'تغيير كلمة المرور' : 'Change Password'}
        </li>
      </ul>
    </div>
  )
}

export default MeunSideSetting